// 国家选择弹窗
import CustomPopup from "../../../../components/CustomPopup";
import {ModalProps} from "../../../../types/IPage.ts";
import React, {useContext, useEffect} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import "./CountrySelectionDialog.css";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import {ICountryRegion} from "../../../../common/utils/http/IResponse.ts";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";


const CountrySelectionDialog: React.FC<ModalProps> = ({isOpen, onClose}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局用户信息provider
    const {user, setUser} = useUserContext();
    // 加载中弹窗
    const {showLoading, hideLoading} = useLoading();
    // 国家列表
    const [countryList, setCountryList] = React.useState<ICountryRegion[]>([]);
    const [selectedCountryCode, setSelectedCountryCode] = React.useState<string>();
    const [selectedCountry, setSelectedCountry] = React.useState<ICountryRegion>();
    // toast弹窗
    const {addToast} = useContext(ToastContext);

    useEffect(() => {
        if (isOpen) {
            getCountryList();
            setSelectedCountryCode(user?.countryCode);
        }
    }, [isOpen]);

    // 获取国家列表
    const getCountryList = async () => {
        try {
            showLoading();
            const res = await apiService.loadCountryList();
            if (res.code === 200) {
                setCountryList(res.data ?? []);
            }
        } catch (e) {
            console.error(e);
            addToast({message: "Failed to load country/region list.", type: "error"})
        } finally {
            hideLoading();

        }
    };

    // 设置选中的国家
    const handleSelectCountryCode = (item: ICountryRegion) => {
        setSelectedCountry(item)
        setSelectedCountryCode(item.countryCode)
    };

    // 修改用户国家/区域
    const changeUserCountry = async () => {
        if (selectedCountry === null || selectedCountry === undefined) {
            addToast({message: "Please select a country/region.", type: "error"})
            return
        }

        try {
            showLoading();
            const response = await apiService.updateUserCountry(selectedCountry!.id)
            if (response.code === 200) {
                // 获取返回的设置好的用户国家，设置前端用户区域
                setUser((preValue) => ({
                    ...preValue,
                    countryCode: response.data.countryCode,
                    country: response.data.countryName
                }))
            }
        } finally {
            hideLoading();
            onClose();
        }
    }


    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="country-selection-modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*标题*/}
                <div
                    className="font-size-16 my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                    Select Your Country/Region
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                         alt="pic"/>
                </div>

                {/*国家列表*/}
                <div
                    className="margin-top-16 height-230 width-273 margin-left-right-auto bg-color-grey display-flex-column display-flex-justify-content-center">
                    {/*内部可滚动的部分*/}
                    <div className="height-215 overflow-y-auto margin-top-6">
                        {countryList.map((item) => {
                            return (
                                <div onClick={() => handleSelectCountryCode(item)} key={item.id}
                                     className="margin-left-14 margin-right-14">
                                    <div
                                        className="font-size-16 my-roboto-regular height-27 display-flex-row display-flex-align-items-center display-flex-space-between">
                                        <div>{item.countryName}</div>
                                        {selectedCountryCode === item.countryCode ?
                                            <img src={imgUrls.checkedBlueIcon}
                                                 className="height-16 width-16 border-radius-round"
                                                 alt="pic"/> : undefined
                                        }
                                    </div>
                                    <div className="split-line margin-top-6 margin-bottom-6"/>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {/*底部确认按钮*/}
                <div onClick={changeUserCountry}
                     className={`${selectedCountry === null || selectedCountry === undefined ? 'bg-color-grey-btn' : 'bg-btn-blue-color'} my-roboto-medium font-size-16 color-white border-radius-34 margin-left-right-auto margin-top-bottom-auto height-43 width-133 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                    Confirm
                </div>
            </div>
        </CustomPopup>
    )
    // Your component implementation here
};

export default CountrySelectionDialog;